import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "title", "breadcrumbs", "backgroundColor", "category", "format", "audience", "startsAt", "place", "image", "button", "layoutType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { Layout } from '@sbercloud/uikit-product-site-layout';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Breadcrumbs } from '@snack-uikit/breadcrumbs';
import { PromoTag } from '@snack-uikit/promo-tag';
import { HERO_COLORS } from '../../constants';
import { HeroEventButton, Place } from '../../helperComponents';
import { AUDIENCE_LABELS, FORMAT_LABELS } from './constants';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroEvent(_ref) {
  var className = _ref.className,
    title = _ref.title,
    breadcrumbs = _ref.breadcrumbs,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? HERO_COLORS.NeutralBackground : _ref$backgroundColor,
    category = _ref.category,
    format = _ref.format,
    audience = _ref.audience,
    startsAt = _ref.startsAt,
    place = _ref.place,
    image = _ref.image,
    button = _ref.button,
    layoutType = _ref.layoutType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var formatTitle = format ? FORMAT_LABELS[format] : undefined;
  var audienceTitle = audience ? AUDIENCE_LABELS[audience] : undefined;
  var showTagRow = Boolean(category || formatTitle || audienceTitle);
  return /*#__PURE__*/_jsx(Layout.SectionWrapper, {
    layoutType: layoutType,
    className: cn(className, styles.sectionWrapper),
    "data-section-background": backgroundColor,
    children: /*#__PURE__*/_jsx("section", _objectSpread(_objectSpread({
      className: styles.wrapper,
      "data-layout-type": layoutType
    }, extractSupportProps(rest)), {}, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.heroEvent,
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsx(Breadcrumbs, {
          size: "xs",
          items: breadcrumbs,
          "data-test-id": "hero-event__breadcrumbs"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          "data-layout-type": layoutType,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.left,
            "data-layout-type": layoutType,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.titleWrapper,
              "data-layout-type": layoutType,
              children: [showTagRow && /*#__PURE__*/_jsxs("div", {
                className: styles.tagRow,
                children: [category && /*#__PURE__*/_jsx(PromoTag, _objectSpread(_objectSpread({}, category), {}, {
                  color: "decor",
                  size: "xs"
                })), formatTitle && /*#__PURE__*/_jsx(PromoTag, {
                  appearance: "violet",
                  text: formatTitle,
                  color: "decor",
                  size: "xs"
                }), audienceTitle && /*#__PURE__*/_jsx(PromoTag, {
                  appearance: "violet",
                  text: audienceTitle,
                  color: "decor",
                  size: "xs"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.textWrapper,
                "data-layout-type": layoutType,
                children: [/*#__PURE__*/_jsx("h1", {
                  className: styles.title,
                  "data-layout-type": layoutType,
                  children: title
                }), /*#__PURE__*/_jsxs("p", {
                  className: styles.coords,
                  "data-color": backgroundColor,
                  children: [/*#__PURE__*/_jsxs("time", {
                    className: styles.time,
                    children: [startsAt, place.title && ', ']
                  }), place.title && /*#__PURE__*/_jsx(Place, _objectSpread(_objectSpread({}, place), {}, {
                    title: place.title
                  }))]
                })]
              })]
            }), /*#__PURE__*/_jsx(HeroEventButton, _objectSpread(_objectSpread({}, button), {}, {
              layoutType: layoutType
            }))]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.imageWrapper,
            "data-layout-type": layoutType,
            children: /*#__PURE__*/_jsx("img", {
              className: styles.image,
              alt: "hero_img",
              src: image,
              "data-layout-type": layoutType
            })
          })]
        })]
      })
    }))
  });
}